const DEV = process.env.NODE_ENV === 'development';
import {
	Tabulator,
	SortModule,
	FilterModule,
	HtmlTableImportModule,
	FormatModule,
	FrozenColumnsModule,
} from 'tabulator-tables';
import '/node_modules/tabulator-tables/dist/css/tabulator.min.css';
import { DateTime } from 'luxon';
import NiceSelect from 'nice-select2';
import 'nice-select2/src/scss/nice-select2.scss';

Tabulator.registerModule([
	SortModule,
	FilterModule,
	HtmlTableImportModule,
	FormatModule,
	FrozenColumnsModule,
]);

export default {
	init() {
		//TABLE
		const loader = document.getElementById('loader'),
			selects = document.querySelectorAll('.table_select'),
			styledSelects = [],
			nameSearch = document.getElementById('nameSearch'),
			papabileCheckbox = document.getElementById('papabile'),
			cardinalElectorCheckbox = document.getElementById('grand_elector'),
			conclaveCheckbox = document.getElementById('conclave'),
			filtersRecap = document.getElementById('filtersRecap'),
			clearFiltersBtn = document.getElementById('clearFilters'),
			totalNumber = document.getElementById('totalNumber'),
			pills = document.getElementById('pills');

		let typingTimer,
			filters = {};

		const table = new Tabulator('#cardinalsTable', {
			dependencies: {
				DateTime: DateTime,
			},
			layout: 'fitDataFill',
			columns: [
				{
					title: 'cardinal',
					field: 'cardinal',
					formatter: 'html',
					width: 220,
					//frozen: true,
				},
				{
					title: 'pays',
					field: 'pays_naissance',
					formatter: customHtml,
					width: 110,
				},
				{
					title: 'pays_naissance',
					field: 'pays_naissance',
					visible: false,
				},
				{
					title: 'continent',
					field: 'continent_naissance',
					formatter: customHtml,
				},
				{
					title: 'continent_naissance',
					field: 'continent_naissance',
					visible: false,
				},
				{
					title: 'Fonction',
					field: 'job_role',
					formatter: customHtml,
					width: 180,
				},
				{
					title: 'job_role',
					field: 'job_role',
					formatter: customHtml,
					width: 250,
					visible: false,
				},
				{
					title: 'conclave',
					field: 'conclave',
					visible: false,
				},
				{
					title: 'elector',
					field: 'elector',
					visible: false,
				},
				// {
				//   title: 'created_by',
				//   field: 'created_by',
				//   formatter: customHtml,
				// },
				// {
				//   title: 'state',
				//   field: 'state',
				//   formatter: customHtml,
				// },
				{
					title: 'position',
					field: 'position',
					formatter: customHtml,
				},
				{
					title: 'age',
					field: 'age',
					formatter: customHtml,
				},
				{
					title: 'papabile',
					field: 'papabile',
					visible: false,
				},
				{
					title: 'grand_elector',
					field: 'grand_elector',
					visible: false,
				},
				{
					title: 'outsider',
					field: 'outsider',
					visible: false,
				},
				{
					title: 'term_id',
					field: 'term_id',
					visible: false,
				},
				{
					title: 'Créé par',
					field: 'pape',
					formatter: customHtml,
				},
				{
					title: 'pape',
					field: 'pape',
					visible: false,
				},

				// {
				//   title: 'elector_until',
				//   field: 'elector_until',
				//   sorter: 'date',
				// },
				{
					title: 'Progressiste / Conservateur',
					field: 'x_coords',
					formatter: customProgress,
					width: 250,
					visible: true,
				},
				{
					title: 'Périphérique / Central',
					field: 'y_coords',
					formatter: customProgress,
					width: 250,
					visible: true,
				},
				{
					title: 'x_coords',
					field: 'x_coords',
					visible: false,
				},
				{
					title: 'y_coords',
					field: 'y_coords',
					visible: false,
				},
				{
					title: 'image_id',
					field: 'image_id',
					visible: false,
				},
			],
		});
		table.on('dataFiltered', function (filters, rows) {
			if (totalNumber) {
				totalNumber.innerHTML = rows.length;
			}
			if (filters.length > 0) {
				filtersRecap.style.display = 'block';
			} else {
				filtersRecap.style.display = 'none';
			}
		});
		table.on('dataProcessed', function () {
			customFilter();
			loader.style.display = 'none';
		});

		selects.forEach((select) => {
			filters[select.name] = null;
			select.addEventListener('change', function (e) {
				filters[select.name] = {
					value: select.value,
					title: select.dataset.title,
				};
				customFilter();
			});

			let niceSelect = new NiceSelect(select, {});

			styledSelects.push(niceSelect);
		});

		nameSearch.addEventListener('keyup', function (e) {
			clearTimeout(typingTimer);
			typingTimer = setTimeout(function () {
				filters.cardinal = {
					value: nameSearch.value,
					title: nameSearch.dataset.title,
				};
				customFilter();
			}, 500);
		});
		nameSearch.addEventListener('keydown', function () {
			clearTimeout(typingTimer);
		});

		papabileCheckbox.addEventListener('change', function () {
			if (papabileCheckbox.checked) {
				cardinalElectorCheckbox.checked = false;
				conclaveCheckbox.checked = false;
				if (filters.grand_elector) filters.grand_elector.value = false;
				if (filters.conclave) filters.conclave.value = false;
			}
			filters['papabile'] = {
				value: papabileCheckbox.checked,
				title: papabileCheckbox.dataset.title,
			};
			customFilter();
		});

		cardinalElectorCheckbox.addEventListener('change', function () {
			if (cardinalElectorCheckbox.checked) {
				papabileCheckbox.checked = false;
				conclaveCheckbox.checked = false;
				if (filters.papabile) filters.papabile.value = false;
				if (filters.conclave) filters.conclave.value = false;
			}
			filters['grand_elector'] = {
				value: cardinalElectorCheckbox.checked,
				title: cardinalElectorCheckbox.dataset.title,
			};
			customFilter();
		});

		conclaveCheckbox.addEventListener('change', function () {
			if (conclaveCheckbox.checked) {
				papabileCheckbox.checked = false;
				cardinalElectorCheckbox.checked = false;
				if (filters.papabile) filters.papabile.value = false;
				if (filters.grand_elector) filters.grand_elector.value = false;
			}
			filters['conclave'] = {
				value: conclaveCheckbox.checked,
				title: conclaveCheckbox.dataset.title,
			};
			customFilter();
		});

		clearFiltersBtn.addEventListener('click', function () {
			resetFilters();
			table.clearFilter();
		});

		pills.addEventListener('click', function (event) {
			if (event.target.classList.contains('value')) {
				let pill = event.target.closest('.filter-pill');
				if (pill) {
					let key = pill.dataset.name;
					filters[key].value = '';
					let inputs = document.querySelectorAll(
						'[name="' + key + '"]'
					);
					inputs.forEach((input, index) => {
						input.value = '';
						if (input.nodeName.toLowerCase() === 'select') {
							let indexInSelects = Array.from(selects).findIndex(
								(select) => select === input
							);
							if (indexInSelects !== -1) {
								styledSelects[indexInSelects].clear();
							}
						}
					});
					pill.remove();
					customFilter();
				}
			}
		});

		function customFilter() {
			let currentFilters = [];

			pills.innerHTML = '';

			Object.keys(filters).forEach(function (key) {
				if (
					filters[key] &&
					filters[key].value != '' &&
					filters[key].value != null
				) {
					if (key == 'age') {
						let values = filters[key].value.split('-');
						let currentFilter1 = {
							field: key,
							type: '>=',
							value: Number(values[0]),
						};
						let currentFilter2 = {
							field: key,
							type: '<=',
							value: Number(values[1]),
						};

						currentFilters.push(currentFilter1, currentFilter2);
					} else {
						let currentFilter = {
							field: key,
							type: key == 'cardinal' ? 'like' : '=',
							value: filters[key].value,
						};
						currentFilters.push(currentFilter);
					}

					if (filters[key].value != true) {
						pills.innerHTML +=
							'<li class="filter-pill" data-name="' +
							key +
							'">' +
							filters[key].title +
							':<div class="value">' +
							filters[key].value +
							'</div></li>';
					}
				}
			});

			//console.log(currentFilters);

			if (currentFilters.length > 0) {
				table.setFilter(currentFilters);
			} else {
				table.clearFilter();
			}
		}

		function resetFilters() {
			nameSearch.value = '';
			papabileCheckbox.checked = false;
			cardinalElectorCheckbox.checked = false;
			selects.forEach((select, index) => {
				select.value = '';
				styledSelects[index].clear();
			});
			filters = {};
			pills.innerHTML = '';
		}

		function customProgress(cell) {
			if (cell.getValue() == null || cell.getValue() == '') {
				return '<div class="cell-content"></div>';
			}
			let val = Math.floor(cell.getValue());
			let left = 10 * val + 50;
			let field = cell.getField();
			let labelInput = document.getElementById(field + 'Label');
			let label = '';
			if (labelInput) {
				label = labelInput.value;
			}
			let html = `<div class="relative w-full">
					<div class="progress_bar relative w-full rounded-full">
						<div style="left: ${left}%" class="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-2.5s h-2.5s rounded-full bg-cardinale">
              <div class="progress_value opacity-0 transition-opacity absolute bottom-full left-1/2 -translate-x-1/2 mb-2s overtitle-article text-[14px] uppercase">${cell.getValue()}</div>
            </div>
					</div>
				</div>`;
			return html;
		}

		function customHtml(cell) {
			return '<div class="cell-content">' + cell.getValue() + '</div>';
		}
	},
	finalize() {},
};
